// extracted by mini-css-extract-plugin
module.exports = {"clearFilters":"InstitutionList_clearFilters__2-FSZ","exportButton":"InstitutionList_exportButton__3KQZ9"};